import { useEffect } from 'react';
import { useProfileStore, useIsProfileInitialized } from '@/store';
import { useServiceVendors } from '@/features/service-vendors';

export function useProfileSelector() {
  const { setProfiles, setError, initializeSelection, validateSelection } = useProfileStore();
  const isInitialized = useIsProfileInitialized();
  const { data, isLoading, isError, error } = useServiceVendors(null, null, 100);

  useEffect(() => {
    if (isError && error) {
      setError(error instanceof Error ? error.message : 'Failed to load profiles');
    } else {
      setError(null);
    }
  }, [isError, error, setError]);

  useEffect(() => {
    if (data?.pages) {
      const profiles = data.pages.flatMap((page) => page.serviceVendors || []);
      setProfiles(profiles);

      if (!isInitialized) {
        initializeSelection();
      } else {
        validateSelection();
      }
    }
  }, [data?.pages, setProfiles, initializeSelection, validateSelection, isInitialized]);

  return { isLoading, isError, error };
}
